import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import { TImportDeposit } from "@/types";

function DetailledReport({ importDeposit }: { importDeposit: TImportDeposit }) {
  const { t } = useTranslation("importDeposit");

  const showRowsErrors = importDeposit.error_in_rows > 0;

  const showReportErrors = importDeposit.report.length > 0;

  return (
    <div className="p-md border-grayscale-xx-light float-left flex-1 items-center justify-center rounded-lg border">
      <Typography as="h2" step="1" weight="bold" className="mb-sm">
        {t("importDeposit:importDetails.detailledReport.title")}
      </Typography>

      {/* First section, the main message. TODO - push for more alignement between styles for all status */}
      {importDeposit.status === "refused" && (
        <div className="bg-negative-xx-light py-3xs px-2xs my-md rounded-sm">
          <Typography
            as="span"
            step="-1"
            weight="semibold"
            className="text-negative"
          >
            {importDeposit.message}
          </Typography>
        </div>
      )}
      {importDeposit.status === "accepted" && (
        <Typography as="span" step="-1" className="my-md">
          {t("importDeposit:importDetails.detailledReport.accepted")}
        </Typography>
      )}
      {importDeposit.status === "integrated" && (
        <div className="gap-y-2xs my-md grid grid-cols-2 grid-rows-2">
          <Typography
            step="-1"
            weight="semibold"
            className="col-start-1 row-start-1"
          >
            {t("importDeposit:importDetails.detailledReport.integrated")}
          </Typography>
          <Typography
            step="-1"
            className="text-grayscale col-start-2 row-start-1 text-right"
          >
            {t("formatter:number", { value: importDeposit.total_rows })}
          </Typography>
        </div>
      )}

      {/* Second section, the stats about errors in rows */}
      {showRowsErrors && (
        <div className="gap-y-2xs my-md grid grid-cols-2 grid-rows-2">
          <Typography
            step="-1"
            weight="semibold"
            className="col-start-1 row-start-1"
          >
            {t("importDeposit:importDetails.detailledReport.errorTotal")}
          </Typography>
          <Typography
            step="-1"
            className="text-grayscale col-start-2 row-start-1 text-right"
          >
            {t("formatter:number", { value: importDeposit.error_in_rows })}
          </Typography>
          <Typography
            step="-1"
            weight="semibold"
            className="col-start-1 row-start-2"
          >
            {t("importDeposit:importDetails.detailledReport.errorPercentage")}
          </Typography>
          <Typography
            step="-1"
            className="text-grayscale col-start-2 row-start-2 text-right"
          >
            {t("formatter:percentage", {
              value: importDeposit.document_errors_percent / 100,
            })}
          </Typography>
        </div>
      )}

      {/* Third section, the content of the detailled report */}
      {showReportErrors && (
        <div className="space-y-2xs">
          {importDeposit.report.map((reportLine, idx) => (
            <Typography weight="semibold" step="-1" as="div" key={idx}>
              {reportLine}
            </Typography>
          ))}
        </div>
      )}
    </div>
  );
}

export default DetailledReport;
